import { isAustralianSite } from '~/utils/region-site-config';

export const DEFAULT_CITY = 'Bangkok';

export const cities = [
  {
    label: 'Where to go?',
    value: '',
    disabled: true
  },
  {
    label: 'Thailand',
    children: isAustralianSite()
      ? [
        { label: 'Ayutthaya', value: 'Ayutthaya' },
        { label: 'Bangkok', value: 'Bangkok' },
        { label: 'Chiang Mai', value: 'Chiang Mai' },
        { label: 'Chiang Rai', value: 'Chiang Rai' },
        { label: 'Hat Yai & Songkhla', value: 'Hat Yai' },
        { label: 'Hua Hin & Prachuap Khiri Khan', value: 'Hua Hin' },
        { label: 'Kanchanaburi', value: 'Kanchanaburi' },
        { label: 'Khao Yai & Nakhon Ratchasima', value: 'Nakhon Ratchasima' },
        { label: 'Koh Samui & Surat Thani', value: 'Surat Thani' },
        { label: 'Pattaya & Chonburi', value: 'Pattaya' },
        { label: 'Phuket', value: 'Phuket' },
      ]
      : [
        { label: 'Ayutthaya', value: 'Ayutthaya' },
        { label: 'Bangkok', value: 'Bangkok' },
        { label: 'Near Bangkok', value: 'Near Bangkok' },
        { label: 'Chiang Mai', value: 'Chiang Mai' },
        { label: 'Near Chiang Mai', value: 'Near Chiang Mai' },
        { label: 'Chiang Rai', value: 'Chiang Rai' },
        { label: 'Hat Yai & Songkhla', value: 'Hat Yai' },
        { label: 'Hua Hin & Prachuap Khiri Khan', value: 'Hua Hin' },
        { label: 'Kanchanaburi', value: 'Kanchanaburi' },
        { label: 'Khao Yai & Nakhon Ratchasima', value: 'Nakhon Ratchasima' },
        { label: 'Koh Samui & Surat Thani', value: 'Surat Thani' },
        { label: 'Pattaya & Chonburi', value: 'Pattaya' },
        { label: 'Phuket', value: 'Phuket' },
        { label: '+44 more cities', value: 'Other' },
      ]
  },
  {
    label: 'Cambodia',
    children: [
      { label: 'Phnom Penh', value: 'Phnom Penh' },
      { label: 'Siem Reap', value: 'Siem Reap' },
      { label: 'Battambang', value: 'Battambang' },
      { label: 'Kampot', value: 'Kampot' },
      { label: 'Mondulkiri', value: 'Mondulkiri' },
    ]
  },
  {
    label: 'Philippines',
    children: [
      { label: 'Manila', value: 'Manila' },
      { label: 'Cebu', value: 'Cebu' },
    ]
  },
  {
    label: 'Vietnam',
    children: [
      { label: 'Ho Chi Minh City (Saigon)', value: 'Ho Chi Minh City (Saigon)' },
      { label: 'Hanoi', value: 'Hanoi' }
    ]
  },
  {
    label: 'Indonesia',
    children: [
      { label: 'Bali', value: 'Bali' },
    ]
  },
  {
    label: 'Australia',
    children: [
      { label: 'Brisbane', value: 'Brisbane' },
      { label: 'Gold Coast', value: 'Gold Coast' },
      { label: 'Byron Bay', value: 'Byron Bay' },
    ]
  }
];

export const cityPageWhiteList = ['Near Bangkok', 'Near Chiang Mai'];

export const activities = [
  { value: 'popular', label: 'Popular Activities', icon: 'activity' },
  { value: 'art-and-craft-workshops', label: 'Art & Craft Workshops', icon: 'picture-frame' },
  { value: 'cooking', label: 'Cooking', icon: 'cooking' },
  { value: 'fitness-and-wellness', label: 'Fitness & Wellness', icon: 'healthcare' },
  { value: 'floating-market', label: 'Floating Markets', icon: 'floating-market' },
  { value: 'food-and-drink', label: 'Food & Drink', icon: 'restaurant' },
  { value: 'fun-and-adventure', label: 'Fun & Adventure', icon: 'activity' },
  { value: 'history-and-culture', label: 'History & Culture', icon: 'pagonda' },
  { value: 'local-life', label: 'Local Life', icon: 'thai-house' },
  { value: 'local-ride', label: 'Local Ride', icon: 'tuktuk' },
  { value: 'nature', label: 'Nature', icon: 'tree' },
  { value: 'night-activities', label: 'Night Activities', icon: 'night' },
  { value: 'shopping', label: 'Shopping', icon: 'shopping' },
  { value: 'volunteering-and-social-impact', label: 'Volunteering & Social Impact', icon: 'volunteer' },
];

export const iconMapping = activities
  .reduce(
    (prev, activity) => {
      return {
        ...prev,
        [activity.value]: activity.icon,
      };
    },
    {}
  );
